/**
 * Path halaman yang dirujuk dari beberapa tempat sekaligus.
 *
 * Disimpan di modul tersendiri tanpa dependensi apa pun supaya bisa diimpor
 * `routes.js` maupun komponen tanpa membuat siklus impor.
 */

/** Tujuan user yang belum punya `mamboo_id`. */
export const DRAFT_KONTRAK_PATH = "/draft-kontrak";

/** Daftar lagu — submenu "List Lagu" di bawah Katalog Lagu. */
export const KATALOG_LAGU_PATH = "/katalog-lagu";

/** Submenu "Register Req" di bawah Katalog Lagu. Halamannya masih placeholder. */
export const REGISTER_REQ_PATH = "/katalog-lagu/register-req";
